import { render, staticRenderFns } from "./message-recharge.vue?vue&type=template&id=5b953969&scoped=true&"
import script from "./message-recharge.vue?vue&type=script&lang=ts&"
export * from "./message-recharge.vue?vue&type=script&lang=ts&"
import style0 from "./message-recharge.vue?vue&type=style&index=0&id=5b953969&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b953969",
  null
  
)

export default component.exports